<template>
  <div id="engine-cards-list">
    <div class="container">
      <h1 class="mt-4">Cards</h1>
      <button @click="createCard()" class="btn btn-outline-secondary"><i class="fal fa-file-plus"></i> New Card</button>
      <b-table striped hover dark :items="cards" :fields="[{key:'name', sortable:true}, {key:'suit.name', label:'Suit', sortable:true}, 'edit']" class="mt-4 mb-5">
        <!-- A virtual column -->
        <template slot="edit" slot-scope="data">
          <button @click="editCard(data.item.id)" class="btn btn-sm btn-outline-secondary"><i class="fal fa-edit"></i></button>
        </template>
      </b-table>
    </div><!-- /.container -->

    <EngineCardBuilder :cardId="editThisCard" v-on:closeCardBuilder="showCardBuilder = false" v-if="showCardBuilder == true" />
  </div><!-- engine-cards-list -->
</template>

<script>
const fb = require('../../firebaseConfig.js')
import EngineCardBuilder from './EngineCardBuilder.vue'

export default {
  data() {
    return {
      cards: [],
      editThisCard: null,
      showCardBuilder: false
    }
  },
  components: {
    EngineCardBuilder
  },
  created() {
    fb.cardsCollection.orderBy("updatedOn", "desc").onSnapshot(cards => {
      this.cards = []
      for (let i = 0; i < cards.docs.length; i++) {
        let cardItem = cards.docs[i].data()
        cardItem.id = cards.docs[i].id
        this.cards.push(cardItem)
      }
    })
  },
  methods: {
    editCard(id) {
      this.editThisCard = id
      this.showCardBuilder = true
    },
    createCard() {
      this.editThisCard = null
      this.showCardBuilder = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/engine/EngineCardsList.vue